import type { ReactNode } from "react";
import { forwardRef } from "react";
import { Portal } from "@/utils/components/Portal";

type ModalProps = {
  children: ReactNode;
  className?: string;
};

export const Modal = forwardRef<HTMLDivElement, ModalProps>(
  ({ children, className }, ref) => {

    return (
      <Portal>
        <div
          ref={ref}
          className={`w-full h-full z-50 flex justify-center items-center bg-main fixed top-0 left-0${className ? ` ${className}` : ""}`}
        >
          {children}
        </div>
      </Portal>
    );
  }
);
